import { MTP_BASE_URL } from '../../../apiRoutes';
import { Auth } from 'aws-amplify';
import { http, handleErrors } from '../../../services/http-wrapper';

//=========GET GRUPOS DE EMPRESA DE UM CLIENTE=============//
export const ApiGetGrupoEmpresaByClient = async ({ clientId }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${MTP_BASE_URL}/records/grupo_empresa/list_by_client/${clientId}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//=========SAVE GRUPO DE EMPRESA=============//
export const ApiSaveGrupoEmpresa = async ({ nome, client_id }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${MTP_BASE_URL}/records/grupo_empresa/save`,
      { nome, client_id },
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//=========UPDATE GRUPO DE EMPRESA=============//
export const ApiUpdateGrupoEmpresa = async ({ id, nome }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.put(
      `${MTP_BASE_URL}/records/grupo_empresa/update/${id}`,
      { nome },
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//=========DELETE GRUPO DE EMPRESA=============//
export const ApiDeleteGrupoEmpresa = async ({ id }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${MTP_BASE_URL}/records/grupo_empresa/delete/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};
